package com.loyola.acessoescola.ui.navigation

import kotlinx.serialization.Serializable

@Serializable
object LoginDest

@Serializable
object RegisteredDest

@Serializable
object HintScreenDest


@Serializable
object PolicyScreenDest

@Serializable
object AdminPanelDest

@Serializable
data class AddNewDest(val recordID: String? = null)